import ProjectHeader from "@/components/AppHeader/ProjectHeader";
import CanvasArchivedModal from "@/components/CanvasArchivedModal";
import { ElementMetadataProvider } from "@/components/contexts/ElementMetadataContext";
import PanelsLayout from "@/components/Layout/PanelsLayout";
import { PreviewGenerator } from "@/components/PreviewGenerator/PreviewGenerator";
import { EditorSideEffects } from "@/components/SideEffects/EditorSideEffects";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import usePlanInfoStore from "@/store/zustand/planInfoStore";
import { useActiveProject } from "@/utils/utils";

const App = () => {
  const project = useActiveProject();

  // The legacy cloud app is retired — canvases are no longer editable. Show the
  // archive/download modal instead of mounting the (now non-functional) editor.
  // Set VITE_DISABLE_ARCHIVED_MODAL=true to restore the live editor.
  if (import.meta.env.VITE_DISABLE_ARCHIVED_MODAL !== "true") {
    return <CanvasArchivedModal />;
  }

  return (
    <>
      <EditorSideEffects />

      <ElementMetadataProvider framework={project?.framework || ""}>
        <PreviewGenerator />
        <div className="flex flex-col h-full w-full max-h-full">
          <ProjectHeader />
          <div className="App relative grow shrink min-h-0">
            <PanelsLayout />
          </div>
        </div>

        <Dialog
          // open={isLocalMode && localModeDevServerStatus === "disconnected"}
          open={false}
        >
          <DialogContent className="sm:max-w-[425px]" hideClose={true}>
            <DialogHeader>
              <DialogTitle>Local Mode Disconnected</DialogTitle>
              <DialogDescription className="text-xs pt-4">
                A connection to the dev server could not be established. Tempo
                will continue trying to reconnect. Check your network connection
                or Tempo server configuration.
              </DialogDescription>
            </DialogHeader>
          </DialogContent>
        </Dialog>
      </ElementMetadataProvider>
    </>
  );
};

export default App;
